import {
    getShopBusiness,
    getShopList,
    getShop,
} from "../apis/api_shop.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list },
    filtersPage: { mode: listMode.page },
    totalCount: 0,
    items: [],
    item: {
        lat:0,
        har:0,
    },
    // business: {
    //     startTime: "",
    //     endTime: ""
    // },
};

const getters = {
};

const mutations = {
    SET_SHOP_LIST(state, data){
        state.items = data.content;
        state.totalCount = data.totalElements;
    },
    SET_SHOP_LIST_PAGE(state, data) {
        data.content.forEach( (item) => {
            state.items.push(item);
        })
        if(state.totalCount != data.totalElements)
            state.totalCount = data.totalElements;
    },

    SET_SHOP(state, payload) {
        state.item = payload
    },

    // SET_SHOP_BUSINESS(state, payload) {
    //     state.business = payload;
    // },

    CLEAR_SHOP(state) {
        state.item = {};
    },
    CLEAR_SHOP_LIST(state) {
        state.items = [];
        state.totalCount = 0;
    },
};

const actions = {

    async GET_SHOP_LIST({ state, commit }, params = {}) {
        let filters = { ...state.filters, ...params }
        try {
            const response = await getShopList(filters);
            commit('SET_SHOP_LIST', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_SHOP_LIST_PAGE({ state, commit }, params = {}) {
        let filters = { ...state.filtersPage, ...params }
        try {
            const response = await getShopList(filters);
            commit('SET_SHOP_LIST_PAGE', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_SHOP({ commit }, id) {
        try {
            const response = await getShop(id);
            commit('SET_SHOP', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_SHOP_BUSINESS(context, params = {}) {
        try {
            let filters = { ...params }
            const response = await getShopBusiness(filters);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }, 
};

export default {mutations, state, actions, getters};